var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 430.63 278.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f36d5b;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #ff8e7d;\n      }\n\n      .cls-36 {\n        fill: #f58989;\n      }\n\n      .cls-3 {\n        fill: #4a7209;\n      }\n\n      .cls-37, .cls-38 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #ba5384;\n      }\n\n      .cls-5 {\n        fill: #ffca9e;\n      }\n\n      .cls-6 {\n        fill: #633da0;\n      }\n\n      .cls-7 {\n        fill: #499002;\n      }\n\n      .cls-8 {\n        fill: #319d00;\n      }\n\n      .cls-9 {\n        fill: #f3e4f3;\n      }\n\n      .cls-39 {\n        opacity: .9;\n      }\n\n      .cls-38 {\n        opacity: 0;\n      }\n\n      .cls-10 {\n        fill: #da7e15;\n      }\n\n      .cls-40 {\n        opacity: .2;\n      }\n\n      .cls-41 {\n        opacity: .2;\n      }\n\n      .cls-42 {\n        opacity: .59;\n      }\n\n      .cls-42, .cls-43 {\n        fill: #d7e9ec;\n        isolation: isolate;\n      }\n\n      .cls-11 {\n        fill: #f97c6f;\n      }\n\n      .cls-44 {\n        fill: #fccbac;\n      }\n\n      .cls-45 {\n        fill: #e58a2e;\n      }\n\n      .cls-12 {\n        fill: #278fce;\n      }\n\n      .cls-13 {\n        fill: #2c71b2;\n      }\n\n      .cls-14 {\n        fill: #fadcf3;\n      }\n\n      .cls-46 {\n        fill: #efa278;\n      }\n\n      .cls-15 {\n        fill: #fd9c4d;\n      }\n\n      .cls-16 {\n        fill: #97b72e;\n      }\n\n      .cls-17 {\n        fill: #54308e;\n      }\n\n      .cls-47 {\n        fill: #f4f2e4;\n      }\n\n      .cls-18 {\n        fill: #25629b;\n      }\n\n      .cls-48 {\n        fill: #ffdb3e;\n      }\n\n      .cls-19 {\n        fill: #ffba02;\n      }\n\n      .cls-43 {\n        opacity: .59;\n      }\n\n      .cls-49 {\n        opacity: .2;\n      }\n\n      .cls-20 {\n        fill: #f8a5e1;\n      }\n\n      .cls-50 {\n        fill: #e85d5d;\n      }\n\n      .cls-21 {\n        fill: #aa3f72;\n      }\n\n      .cls-22 {\n        fill: #738823;\n      }\n\n      .cls-23 {\n        fill: #164466;\n      }\n\n      .cls-51 {\n        fill: #bf672c;\n      }\n\n      .cls-52 {\n        fill: #161616;\n      }\n\n      .cls-53 {\n        opacity: .2;\n      }\n\n      .cls-24 {\n        fill: #ed9400;\n      }\n\n      .cls-25 {\n        fill: #9e3665;\n      }\n\n      .cls-54 {\n        fill: #eac9c5;\n      }\n\n      .cls-26 {\n        fill: #b7db1f;\n      }\n\n      .cls-55 {\n        fill: #ffb023;\n      }\n\n      .cls-56 {\n        fill: #fee9e6;\n      }\n\n      .cls-27 {\n        fill: #49297c;\n      }\n\n      .cls-28 {\n        fill: #a7cd35;\n      }\n\n      .cls-29 {\n        fill: #fc9289;\n      }\n\n      .cls-30 {\n        fill: #fcd8bc;\n      }\n\n      .cls-31 {\n        fill: #d07107;\n      }\n\n      .cls-32 {\n        fill: #39245d;\n      }\n\n      .cls-33 {\n        fill: #ce709f;\n      }\n\n      .cls-34 {\n        fill: #f6c6ed;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CakeBooked"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "cakeShadow",
    className: "cls-43",
    cx: 215.37,
    cy: 239.16,
    rx: 128,
    ry: 34
  }), /*#__PURE__*/React.createElement("g", {
    id: "Presents"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    className: "cls-42",
    d: "m55.01,180.88l-18.73,10.2h106.26l-22.51-10.2H55.01Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    className: "cls-45",
    d: "m86.98,108.82c-.07.01-.15.01-.23,0-3.98-.65-8.79-3.18-13.53-5.68-6.84-3.6-13.53-7.12-16.62-4.51-.33.28-.82.24-1.1-.09-.04-.05-.08-.1-.1-.16-.27-.47-.19-1.07.21-1.44,3.88-3.28,11.01.47,18.3,4.31,4.64,2.44,9.34,4.91,13.07,5.52,3.73-.61,8.43-3.08,13.07-5.52,7.28-3.83,14.42-7.59,18.3-4.31.4.37.48.97.21,1.44-.19.39-.65.54-1.04.36-.06-.03-.11-.06-.16-.1-3.09-2.61-9.78.91-16.62,4.51-4.74,2.5-9.56,5.03-13.53,5.68-.07.01-.15.01-.23,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    className: "cls-45",
    d: "m85.71,104.98c-.73-6.95-4.29-33.19-15.88-21.89-9.71,9.46,10.46,19.45,15.88,21.89Zm1.27-3.84c1.47-10.4,6.06-31.51,18.23-19.65,13.04,12.72-15.25,24.98-17.54,25.95l.05.59-.73-.3-.73.3.05-.59c-2.29-.96-30.59-13.23-17.54-25.95,12.17-11.86,16.76,9.25,18.23,19.65Zm17.14-18.05c-11.58-11.3-15.15,14.94-15.88,21.89,5.41-2.44,25.58-12.43,15.88-21.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    className: "cls-29",
    d: "m45.73,106.09h82.96s.07.03.07.07h0v19.37s-.03.07-.07.07H45.73s-.07-.03-.07-.07h0v-19.37s.03-.07.07-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    className: "cls-11",
    d: "m49.34,125.6h75.41v59.47c0,.51-.41.92-.92.92H50.26c-.51,0-.92-.41-.92-.92v-59.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    className: "cls-10",
    d: "m86.07,106.09h1.96v19.51h-1.96v-19.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    className: "cls-1",
    d: "m49.69,125.6h75.07v2.77H49.69v-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    className: "cls-10",
    d: "m86.07,128.37h1.96v57.61h-1.96v-57.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    className: "cls-31",
    d: "m86.07,125.6h1.96v2.77h-1.96v-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    className: "cls-2",
    d: "m124.76,128.52c0,30.67-14.14,55.53-31.57,55.53v1.94h30.43c.63,0,1.15-.38,1.15-.84v-56.63Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726",
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1880-2",
    "data-name": "Path 1880-2",
    d: "m86.98,108.82c-.07.01-.15.01-.23,0-3.98-.65-8.79-3.18-13.53-5.68-6.84-3.6-13.53-7.12-16.62-4.51-.33.28-.82.24-1.1-.09-.04-.05-.08-.1-.1-.16-.27-.47-.19-1.07.21-1.44,3.88-3.28,11.01.47,18.3,4.31,4.64,2.44,9.34,4.91,13.07,5.52,3.73-.61,8.43-3.08,13.07-5.52,7.28-3.83,14.42-7.59,18.3-4.31.4.37.48.97.21,1.44-.19.39-.65.54-1.04.36-.06-.03-.11-.06-.16-.1-3.09-2.61-9.78.91-16.62,4.51-4.74,2.5-9.56,5.03-13.53,5.68-.07.01-.15.01-.23,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881-2",
    "data-name": "Path 1881-2",
    d: "m85.71,104.98c-.73-6.95-4.29-33.19-15.88-21.89-9.71,9.46,10.46,19.45,15.88,21.89Zm1.27-3.84c1.47-10.4,6.06-31.51,18.23-19.65,13.04,12.72-15.25,24.98-17.54,25.95l.05.59-.73-.3-.73.3.05-.59c-2.29-.96-30.59-13.23-17.54-25.95,12.17-11.86,16.76,9.25,18.23,19.65Zm17.14-18.05c-11.58-11.3-15.15,14.94-15.88,21.89,5.41-2.44,25.58-12.43,15.88-21.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882-2",
    "data-name": "Path 1882-2",
    className: "cls-35",
    d: "m45.73,106.09h82.96s.07.03.07.07h0v19.37s-.03.07-.07.07H45.73s-.07-.03-.07-.07h0v-19.37s.03-.07.07-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883-2",
    "data-name": "Path 1883-2",
    className: "cls-35",
    d: "m49.34,125.6h75.41v59.47c0,.51-.41.92-.92.92H50.26c-.51,0-.92-.41-.92-.92v-59.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1884-2",
    "data-name": "Path 1884-2",
    className: "cls-35",
    d: "m86.07,106.09h1.96v19.51h-1.96v-19.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1885-2",
    "data-name": "Path 1885-2",
    className: "cls-35",
    d: "m49.69,125.6h75.07v2.77H49.69v-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886-2",
    "data-name": "Path 1886-2",
    className: "cls-35",
    d: "m86.07,128.37h1.96v57.61h-1.96v-57.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1887-2",
    "data-name": "Path 1887-2",
    className: "cls-35",
    d: "m86.07,125.6h1.96v2.77h-1.96v-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888-2",
    "data-name": "Path 1888-2",
    className: "cls-35",
    d: "m124.76,128.52c0,30.67-14.14,55.53-31.57,55.53v1.94h30.43c.63,0,1.15-.38,1.15-.84v-56.63Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1910",
    "data-name": "Path 1910",
    className: "cls-42",
    d: "m72.46,201.86l-18.73,10.2h106.26l-22.51-10.2h-65.02Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    className: "cls-9",
    d: "m63.53,163.57h87.42s.06.03.06.06v17.02s-.03.06-.06.06H63.53s-.06-.03-.06-.06v-17.02s.03-.06.06-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    className: "cls-34",
    d: "m67.35,180.72h79.44v26.22c0,.22-.18.4-.4.4h-78.63c-.22,0-.4-.18-.4-.4v-26.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    className: "cls-33",
    d: "m100.61,163.57h12.92v17.15h-12.92v-17.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    className: "cls-20",
    d: "m67.71,180.72h79.08v2.44h-79.08v-2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    className: "cls-4",
    d: "m100.61,183.16h12.92v24.18h-12.92v-24.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    className: "cls-21",
    d: "m100.61,180.72h12.92v2.44h-12.92v-2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    className: "cls-14",
    d: "m146.79,182.01c0,13.52-14.89,24.48-33.26,24.48v.86h32.05c.66,0,1.21-.17,1.21-.37v-24.97h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    className: "cls-33",
    d: "m102.9,157.55c-35.15-30.54-33.29,3.4-14.27,5.99h13.64l.63-5.99h0Zm-1.26.95s-20.35-12.78-21.29-7.1c-1.38,8.28,19.61,13.82,21.21,11.16.99-1.63.08-4.06.08-4.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    className: "cls-33",
    d: "m110.94,157.55c35.15-30.54,33.29,3.4,14.27,5.99h-13.64l-.63-5.99Zm1.26.95s20.35-12.78,21.29-7.1c1.38,8.28-19.61,13.82-21.22,11.16-.99-1.63-.08-4.06-.08-4.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    className: "cls-25",
    d: "m107.04,163.57h-7.41c-.05-4.09,3.24-7.45,7.33-7.5,4.09-.05,7.45,3.24,7.5,7.33,0,.05,0,.11,0,.16h-7.42Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720",
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1860-2",
    "data-name": "Path 1860-2",
    className: "cls-35",
    d: "m63.53,163.79h87.42s.06.03.06.06v17.02s-.03.06-.06.06H63.53s-.06-.03-.06-.06v-17.02s.03-.06.06-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861-2",
    "data-name": "Path 1861-2",
    className: "cls-35",
    d: "m67.35,180.94h79.44v26.22c0,.22-.18.4-.4.4h-78.63c-.22,0-.4-.18-.4-.4v-26.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862-2",
    "data-name": "Path 1862-2",
    className: "cls-35",
    d: "m100.61,163.79h12.92v17.15h-12.92v-17.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863-2",
    "data-name": "Path 1863-2",
    className: "cls-35",
    d: "m67.71,180.94h79.08v2.44h-79.08v-2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864-2",
    "data-name": "Path 1864-2",
    className: "cls-35",
    d: "m100.61,183.38h12.92v24.18h-12.92v-24.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865-2",
    "data-name": "Path 1865-2",
    className: "cls-35",
    d: "m100.61,180.94h12.92v2.44h-12.92v-2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866-2",
    "data-name": "Path 1866-2",
    className: "cls-35",
    d: "m146.79,182.23c0,13.52-14.89,24.48-33.26,24.48v.86h32.05c.66,0,1.21-.17,1.21-.37v-24.97h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867-2",
    "data-name": "Path 1867-2",
    className: "cls-35",
    d: "m102.9,157.76c-35.15-30.54-33.29,3.4-14.27,5.99h13.64l.63-5.99h0Zm-1.26.95s-20.35-12.78-21.29-7.1c-1.38,8.28,19.61,13.82,21.21,11.16.99-1.63.08-4.06.08-4.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868-2",
    "data-name": "Path 1868-2",
    className: "cls-35",
    d: "m110.94,157.76c35.15-30.54,33.29,3.4,14.27,5.99h-13.64l-.63-5.99Zm1.26.95s20.35-12.78,21.29-7.1c1.38,8.28-19.61,13.82-21.22,11.16-.99-1.63-.08-4.06-.08-4.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869-2",
    "data-name": "Path 1869-2",
    className: "cls-35",
    d: "m107.04,163.79h-7.41c-.05-4.09,3.24-7.45,7.33-7.5,4.09-.05,7.45,3.24,7.5,7.33,0,.05,0,.11,0,.16h-7.42Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    className: "cls-26",
    d: "m293.59,126.65h53.03c.51,0,.92.41.92.92v8.9c0,.51-.41.92-.92.92h-53.03c-.51,0-.92-.41-.92-.92v-8.9c0-.51.41-.92.92-.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    className: "cls-16",
    d: "m295.1,137.4h49.8v50.82c0,2.07-1.68,3.75-3.75,3.75h-42.29c-2.07,0-3.75-1.68-3.75-3.75v-50.82h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    className: "cls-8",
    d: "m315.95,126.65h8.1v10.75h-8.1v-10.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    className: "cls-22",
    d: "m295.32,137.4h49.57v1.53h-49.57v-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    className: "cls-7",
    d: "m315.95,138.93h8.1v53.05h-8.1v-53.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    className: "cls-3",
    d: "m315.95,137.4h8.1v1.53h-8.1v-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    className: "cls-28",
    d: "m344.9,140.04c0,27.72-9.33,50.19-20.85,50.19v1.76h18.46c1.31,0,2.39-1.85,2.39-4.11v-47.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    className: "cls-8",
    d: "m319.24,124.99s-16.01-17.88-20.65-9.05c-4.71,8.97,8.69,10.22,16.21,10.71h3.11l1.33-1.66h0Zm-2.17,1s-14.09-8.04-15.73-5.08,15.73,5.08,15.73,5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    className: "cls-8",
    d: "m320.77,124.99s16.01-17.88,20.65-9.05c4.71,8.97-8.69,10.22-16.21,10.71h-3.1l-1.33-1.66h0Zm2.17,1s14.09-8.04,15.72-5.08-15.72,5.08-15.72,5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    className: "cls-8",
    d: "m321.61,125.86s11-27.32-1.24-27.64c-14.23-.37-4.44,19.93-1.66,26.89l.17.15,2.72.6h0Zm-1.96-3.25s2.67-16.36-.74-16.86.74,16.86.74,16.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    className: "cls-3",
    d: "m320.11,126.65h-5.1c0-2.82,2.28-5.1,5.1-5.1s5.1,2.28,5.1,5.1h-5.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    className: "cls-42",
    d: "m284.9,186.69l-18.73,10.2h106.26l-22.51-10.2h-65.02Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722",
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1849-2",
    "data-name": "Path 1849-2",
    className: "cls-35",
    d: "m293.59,126.65h53.03c.51,0,.92.41.92.92v8.9c0,.51-.41.92-.92.92h-53.03c-.51,0-.92-.41-.92-.92v-8.9c0-.51.41-.92.92-.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850-2",
    "data-name": "Path 1850-2",
    className: "cls-35",
    d: "m295.1,137.4h49.8v50.82c0,2.07-1.68,3.75-3.75,3.75h-42.29c-2.07,0-3.75-1.68-3.75-3.75v-50.82h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1851-2",
    "data-name": "Path 1851-2",
    className: "cls-35",
    d: "m315.95,126.65h8.1v10.75h-8.1v-10.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852-2",
    "data-name": "Path 1852-2",
    className: "cls-35",
    d: "m295.32,137.4h49.57v1.53h-49.57v-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853-2",
    "data-name": "Path 1853-2",
    className: "cls-35",
    d: "m315.95,138.93h8.1v53.05h-8.1v-53.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854-2",
    "data-name": "Path 1854-2",
    className: "cls-35",
    d: "m315.95,137.4h8.1v1.53h-8.1v-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855-2",
    "data-name": "Path 1855-2",
    className: "cls-35",
    d: "m344.9,140.04c0,27.72-9.33,50.19-20.85,50.19v1.76h18.46c1.31,0,2.39-1.85,2.39-4.11v-47.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856-2",
    "data-name": "Path 1856-2",
    className: "cls-35",
    d: "m319.24,124.99s-16.01-17.88-20.65-9.05c-4.71,8.97,8.69,10.22,16.21,10.71h3.11l1.33-1.66h0Zm-2.17,1s-14.09-8.04-15.73-5.08,15.73,5.08,15.73,5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857-2",
    "data-name": "Path 1857-2",
    className: "cls-35",
    d: "m320.77,124.99s16.01-17.88,20.65-9.05c4.71,8.97-8.69,10.22-16.21,10.71h-3.1l-1.33-1.66h0Zm2.17,1s14.09-8.04,15.72-5.08-15.72,5.08-15.72,5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858-2",
    "data-name": "Path 1858-2",
    className: "cls-35",
    d: "m321.61,125.86s11-27.32-1.24-27.64c-14.23-.37-4.44,19.93-1.66,26.89l.17.15,2.72.6h0Zm-1.96-3.25s2.67-16.36-.74-16.86.74,16.86.74,16.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859-2",
    "data-name": "Path 1859-2",
    className: "cls-35",
    d: "m320.11,126.65h-5.1c0-2.82,2.28-5.1,5.1-5.1s5.1,2.28,5.1,5.1h-5.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1912",
    "data-name": "Path 1912",
    className: "cls-42",
    d: "m274.28,207.56l-18.73,10.2h106.26l-22.51-10.2h-65.02Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    className: "cls-12",
    d: "m280.36,164.85h61.56s.04.02.04.04v11.99s-.02.04-.04.04h-61.56s-.04-.02-.04-.04v-11.99s.02-.04.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    className: "cls-18",
    d: "m283.05,176.93h55.95v36.8c0,.31-.25.57-.57.57h-54.81c-.31,0-.57-.25-.57-.57v-36.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    className: "cls-30",
    d: "m306.47,164.85h9.1v12.08h-9.1v-12.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    className: "cls-23",
    d: "m283.3,176.93h55.69v1.72h-55.69v-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    className: "cls-5",
    d: "m306.47,178.64h9.1v35.65h-9.1v-35.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    className: "cls-15",
    d: "m306.47,176.93h9.1v1.72h-9.1v-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    "data-name": "Path 1876",
    className: "cls-13",
    d: "m338.99,178.74c0,18.98-10.49,34.36-23.42,34.36v1.2h22.57c.47,0,.85-.23.85-.52v-35.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    className: "cls-30",
    d: "m315.26,160.34c28.6-24.54,24.34,1.69,14.14,4.52h-13.75l-.39-4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    className: "cls-30",
    d: "m306.96,160.34c-28.6-24.54-24.34,1.69-14.14,4.52h13.75l.39-4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    className: "cls-15",
    d: "m311.14,164.85h-6.15c-.05-3.4,2.67-6.19,6.07-6.24,3.4-.05,6.19,2.67,6.24,6.07,0,.06,0,.11,0,.17h-6.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724",
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1870-2",
    "data-name": "Path 1870-2",
    className: "cls-35",
    d: "m280.36,164.85h61.56s.04.02.04.04v11.99s-.02.04-.04.04h-61.56s-.04-.02-.04-.04v-11.99s.02-.04.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871-2",
    "data-name": "Path 1871-2",
    className: "cls-35",
    d: "m283.05,176.93h55.95v36.8c0,.31-.25.57-.57.57h-54.81c-.31,0-.57-.25-.57-.57v-36.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872-2",
    "data-name": "Path 1872-2",
    className: "cls-35",
    d: "m306.47,164.85h9.1v12.08h-9.1v-12.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1873-2",
    "data-name": "Path 1873-2",
    className: "cls-35",
    d: "m283.3,176.93h55.69v1.72h-55.69v-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1874-2",
    "data-name": "Path 1874-2",
    className: "cls-35",
    d: "m306.47,178.64h9.1v35.65h-9.1v-35.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1875-2",
    "data-name": "Path 1875-2",
    className: "cls-35",
    d: "m306.47,176.93h9.1v1.72h-9.1v-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1876-2",
    "data-name": "Path 1876-2",
    className: "cls-35",
    d: "m338.99,178.74c0,18.98-10.49,34.36-23.42,34.36v1.2h22.57c.47,0,.85-.23.85-.52v-35.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1877-2",
    "data-name": "Path 1877-2",
    className: "cls-35",
    d: "m315.26,160.34c28.6-24.54,24.34,1.69,14.14,4.52h-13.75l-.39-4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1878-2",
    "data-name": "Path 1878-2",
    className: "cls-35",
    d: "m306.96,160.34c-28.6-24.54-24.34,1.69-14.14,4.52h13.75l.39-4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1879-2",
    "data-name": "Path 1879-2",
    className: "cls-35",
    d: "m311.14,164.85h-6.15c-.05-3.4,2.67-6.19,6.07-6.24,3.4-.05,6.19,2.67,6.24,6.07,0,.06,0,.11,0,.17h-6.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    className: "cls-42",
    d: "m343.1,240.16l-18.73,10.2h106.26l-22.51-10.2h-65.02Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1889",
    "data-name": "Path 1889",
    className: "cls-6",
    d: "m339.13,153.77h76.74s.05.02.05.05v14.95s-.02.05-.05.05h-76.74s-.05-.02-.05-.05v-14.95s.02-.05.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1890",
    "data-name": "Path 1890",
    className: "cls-27",
    d: "m342.48,168.83h69.74v75.38c0,.58-.47,1.06-1.06,1.06h-67.62c-.58,0-1.06-.47-1.06-1.06v-75.38h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1891",
    "data-name": "Path 1891",
    className: "cls-19",
    d: "m371.68,153.77h11.35v15.05h-11.35v-15.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1892",
    "data-name": "Path 1892",
    className: "cls-32",
    d: "m342.79,168.83h69.43v2.14h-69.43v-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1893",
    "data-name": "Path 1893",
    className: "cls-19",
    d: "m371.68,170.97h11.35v74.29h-11.35v-74.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    className: "cls-24",
    d: "m371.68,168.83h11.35v2.14h-11.35v-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    className: "cls-17",
    d: "m412.22,172.52c0,38.82-13.07,70.28-29.2,70.28v2.46h28.14c.58,0,1.06-.47,1.06-1.06v-71.68h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    className: "cls-19",
    d: "m377.35,153.4s5.46-14.61,10.35-10.36c4.97,4.31-2.84,8.24-7.28,10.32l-1.88.74-1.2-.69h0Zm1.55.09s6.62-8.2,8.31-6.79-8.31,6.79-8.31,6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1897",
    "data-name": "Path 1897",
    className: "cls-19",
    d: "m378.54,154.24s7.15-17.75-.8-17.96c-9.25-.24-2.88,12.95-1.08,17.47l.11.1,1.77.39h0Zm-1.27-2.11s1.74-10.63-.48-10.96.48,10.96.48,10.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1898",
    "data-name": "Path 1898",
    className: "cls-19",
    d: "m377.94,153.13s-5.46-14.61-10.35-10.36c-4.97,4.31,2.84,8.24,7.28,10.32l1.88.74,1.2-.69h0Zm-1.55.09s-6.62-8.2-8.31-6.79,8.31,6.79,8.31,6.79Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739",
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1889-2",
    "data-name": "Path 1889-2",
    className: "cls-35",
    d: "m339.13,153.77h76.74s.05.02.05.05v14.95s-.02.05-.05.05h-76.74s-.05-.02-.05-.05v-14.95s.02-.05.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1890-2",
    "data-name": "Path 1890-2",
    className: "cls-35",
    d: "m342.48,168.83h69.74v75.38c0,.58-.47,1.06-1.06,1.06h-67.62c-.58,0-1.06-.47-1.06-1.06v-75.38h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1891-2",
    "data-name": "Path 1891-2",
    className: "cls-35",
    d: "m371.68,153.77h11.35v15.05h-11.35v-15.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1892-2",
    "data-name": "Path 1892-2",
    className: "cls-35",
    d: "m342.79,168.83h69.43v2.14h-69.43v-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1893-2",
    "data-name": "Path 1893-2",
    className: "cls-35",
    d: "m371.68,170.97h11.35v74.29h-11.35v-74.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1894-2",
    "data-name": "Path 1894-2",
    className: "cls-35",
    d: "m371.68,168.83h11.35v2.14h-11.35v-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895-2",
    "data-name": "Path 1895-2",
    className: "cls-35",
    d: "m412.22,172.52c0,38.82-13.07,70.28-29.2,70.28v2.46h28.14c.58,0,1.06-.47,1.06-1.06v-71.68h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1896-2",
    "data-name": "Path 1896-2",
    className: "cls-35",
    d: "m377.35,153.4s5.46-14.61,10.35-10.36c4.97,4.31-2.84,8.24-7.28,10.32l-1.88.74-1.2-.69h0Zm1.55.09s6.62-8.2,8.31-6.79-8.31,6.79-8.31,6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1897-2",
    "data-name": "Path 1897-2",
    className: "cls-35",
    d: "m378.54,154.24s7.15-17.75-.8-17.96c-9.25-.24-2.88,12.95-1.08,17.47l.11.1,1.77.39h0Zm-1.27-2.11s1.74-10.63-.48-10.96.48,10.96.48,10.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1898-2",
    "data-name": "Path 1898-2",
    className: "cls-35",
    d: "m377.94,153.13s-5.46-14.61-10.35-10.36c-4.97,4.31,2.84,8.24,7.28,10.32l1.88.74,1.2-.69h0Zm-1.55.09s-6.62-8.2-8.31-6.79,8.31,6.79,8.31,6.79Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cake_notbooked",
    "data-name": "cake notbooked"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    className: "cls-44",
    d: "m112.59,204.37v36.1h0c.1,11.9,46.1,21.5,102.9,21.5s102.8-9.6,102.9-21.5h0v-36.1H112.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    className: "cls-51",
    d: "m215.49,258.17c-56.7,0-102.8-9.6-102.9-21.5h0v3.8h0c.1,11.9,46.1,21.5,102.9,21.5s102.8-9.6,102.9-21.5h0v-3.8h0c-.2,11.9-46.2,21.5-102.9,21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    className: "cls-36",
    d: "m112.59,176.27v36.1h0c.1,11.9,46.1,21.5,102.9,21.5s102.8-9.6,102.9-21.5h0v-36.1H112.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    className: "cls-47",
    d: "m112.59,160.57v27.9h0c.1,11.9,46.1,21.5,102.9,21.5s102.8-9.6,102.9-21.5h0v-27.9H112.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    className: "cls-37",
    d: "m323.69,213.77c-1.58-2.77-2.41-5.91-2.4-9.1,0,0,.4-24.1-.1-37.8-.3-8-2.2-16.6-14.8-21.6-18.4-7-52.3-11.7-91-11.7s-75.4,5.1-93.2,12.6c-11.1,5-12.5,13.5-12.5,16.9v39.1c0,4.2-1,8.35-2.9,12.1-.78,1.55-.95,3.33-.5,5,1.6,6.4,6.5,6.7,6.5,6.7v-37.3c0-3.5,2-6.9,5.3-7.9,1.07-.33,2.21-.37,3.3-.1,4.7,1.3,9.5,4.2,10.1,9.9.6,5.6-1.8,14.4,0,19.6,1.4,3.8,6.8,2,7.5.4,1.9-4.1-.9-11.6.6-18.2,1.6-6.6,10-5.9,11.3-1.3.7,2.8.8,12.4.8,19.6,0,4.5-1.5,6.4-2.8,11.7-1.5,6.1,2.2,9.2,4.5,9.4,2.6.2,6-3.2,5.2-7.9-.93-4.34-1.47-8.76-1.6-13.2,0-5.2.3-11.4,1.5-14.9,1.34-4.26,5.88-6.63,10.14-5.3.85.27,1.65.67,2.36,1.2,3.1,2.5,3.3,14.2,12.2,13.3s4.1-12.4,15-10.8c10,1.4,8.6,19.2,16.6,20.7,8,1.4,5-22.7,17.8-21.6,7.2.6,7.4,26,6.3,29.9s-2.2,11.3,3.7,10.8c4.8-.4,3.6-6.8,3-10.3-.6-3.9.3-18.3,1.4-22.9s7.7-4.4,9.1.3,4.3,45,4.2,47.4c-.3,6.4,10.1,5.4,7.7-.2-2.3-5.6-2.8-8.7-2.8-11.6,0-7,2.3-21.8,3-35,.3-6.7,6.8-12.7,11.8-9.5,5.9,3.8,4.6,25.5,4.6,25.5,0,0-3.6,14.1,1.6,15.4,7.6,1.8,5.9-9.3,4.5-14.4-1.4-5.2-.8-23.9,1.4-24.9,9.1-4.2,5.2,17.4,14.1,14.5,4.8-1.5,4.9-10.7,6.9-17.5,1.6-5.3,4.9-2.2,4.9-.6l.3,34c2.76-.26,5.09-2.15,5.9-4.8.61-1.86.43-3.88-.5-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    className: "cls-37",
    d: "m112.59,177.47v49.7c.6.29,1.24.49,1.9.6v-37.3c0-3.5,2-6.9,5.3-7.9,1.07-.33,2.21-.37,3.3-.1,4.7,1.3,9.5,4.2,10.1,9.9.6,5.6-1.9,14.4,0,19.6,1.4,3.8,6.8,2,7.5.4,1.9-4.1-.9-11.6.6-18.2,1.6-6.6,10-5.9,11.3-1.3.8,2.8.8,12.4.8,19.6,0,4.5-1.5,6.4-2.8,11.7-1.5,6.1,2.2,9.2,4.5,9.4,2.6.2,6-3.2,5.2-7.9-.93-4.34-1.47-8.76-1.6-13.2,0-5.2.3-11.4,1.5-14.9,1.34-4.26,5.88-6.63,10.14-5.3.85.27,1.65.67,2.36,1.2,3.1,2.5,3.3,14.2,12.2,13.3s4.1-12.4,15-10.8c10,1.4,8.6,19.2,16.6,20.7,8,1.4,5-22.7,17.8-21.6,7.2.6,7.4,26,6.3,29.9s-2.2,11.3,3.7,10.8c4.8-.4,3.6-6.8,3-10.3-.6-3.9.3-18.3,1.4-22.9s7.7-4.4,9.1.3,4.3,45,4.2,47.4c-.3,6.4,10.1,5.4,7.7-.2-2.3-5.6-2.8-8.7-2.8-11.6,0-7,2.3-21.8,3-35,.3-6.7,6.8-12.7,11.8-9.5,5.9,3.8,4.6,25.5,4.6,25.5,0,0-3.6,14.1,1.6,15.4,7.6,1.8,5.9-9.3,4.5-14.4-1.4-5.2-.8-23.9,1.4-24.9,9.1-4.2,5.2,17.4,14.1,14.6,4.8-1.5,4.9-10.7,6.9-17.5.9-3.2,2.5-3.3,3.6-2.6v-29.4H112.59v16.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    className: "cls-50",
    d: "m172.89,216.57c0-1.82-1.48-3.3-3.3-3.3s-3.3,1.48-3.3,3.3,1.48,3.3,3.3,3.3h0c1.82-.02,3.28-1.48,3.3-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    className: "cls-50",
    d: "m192.59,224.97c0-1.55-1.25-2.8-2.8-2.8s-2.8,1.25-2.8,2.8c.03,1.53,1.27,2.77,2.8,2.8,1.55,0,2.8-1.25,2.8-2.8h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    className: "cls-50",
    cx: 221.19,
    cy: 220.77,
    r: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    className: "cls-50",
    d: "m139.09,220.77c0-1.27-1.03-2.3-2.3-2.3s-2.3,1.03-2.3,2.3,1.03,2.3,2.3,2.3h0c1.26-.01,2.29-1.04,2.3-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    className: "cls-46",
    d: "m164.89,247.47c0-1.05-.85-1.9-1.9-1.9-1.05,0-1.9.85-1.9,1.9,0,1.05.85,1.9,1.9,1.9h0c1.05,0,1.9-.85,1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    className: "cls-46",
    d: "m186.49,244.67c0-1.55-1.25-2.8-2.8-2.8s-2.8,1.25-2.8,2.8c.03,1.53,1.27,2.77,2.8,2.8,1.55,0,2.8-1.25,2.8-2.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    className: "cls-46",
    d: "m212.29,255.47c0-1.55-1.25-2.8-2.8-2.8s-2.8,1.25-2.8,2.8,1.25,2.8,2.8,2.8h0c1.55,0,2.8-1.25,2.8-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    className: "cls-46",
    d: "m125.89,241.37c0-1.05-.85-1.9-1.9-1.9-1.05,0-1.9.85-1.9,1.9,0,1.05.85,1.9,1.9,1.9h0c1.02.03,1.87-.76,1.9-1.78,0-.04,0-.08,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    className: "cls-46",
    d: "m251.69,245.67c0-1.27-1.03-2.3-2.3-2.3s-2.3,1.03-2.3,2.3,1.03,2.3,2.3,2.3h0c1.25.02,2.28-.98,2.3-2.23,0-.02,0-.05,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    className: "cls-46",
    d: "m305.69,236.27c0-1.55-1.25-2.8-2.8-2.8s-2.8,1.25-2.8,2.8c0,1.55,1.25,2.8,2.8,2.8h0c1.53-.03,2.77-1.27,2.8-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    className: "cls-46",
    d: "m296.09,247.47c0-1.16-.94-2.1-2.1-2.1-1.16,0-2.1.94-2.1,2.1s.94,2.1,2.1,2.1h0c1.13.03,2.07-.87,2.1-2,0-.03,0-.07,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    className: "cls-46",
    d: "m285.49,244.67c0-1.82-1.48-3.3-3.3-3.3s-3.3,1.48-3.3,3.3,1.48,3.3,3.3,3.3h0c1.82-.02,3.28-1.48,3.3-3.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    className: "cls-37",
    d: "m323.69,213.77c-1.58-2.77-2.41-5.91-2.4-9.1,0,0,.4-24.1-.1-37.8-.3-8-2.2-16.6-14.8-21.6-18.4-7-52.3-11.7-91-11.7s-75.4,5.1-93.2,12.6c-11.1,5-12.5,13.5-12.5,16.9v39.1c0,4.2-1,8.35-2.9,12.1-.78,1.55-.95,3.33-.5,5,1.6,6.4,6.5,6.7,6.5,6.7v-37.3c0-3.5,2-6.9,5.3-7.9,1-.3,11.2-2.6,13.4,9.7,1,5.6-1.8,14.4,0,19.6,1.4,3.8,6.8,2,7.5.4,1.9-4.1-.9-11.6.6-18.2,1.6-6.6,10-5.9,11.3-1.3.7,2.8.8,12.4.8,19.6,0,4.5-1.5,6.4-2.8,11.7-1.5,6.1,2.2,9.2,4.5,9.4,2.6.2,6-3.2,5.2-7.9-.93-4.34-1.47-8.76-1.6-13.2,0-5.2.3-11.4,1.5-14.9,1.34-4.26,5.88-6.63,10.14-5.3.85.27,1.65.67,2.36,1.2,3.1,2.5,3.3,14.2,12.2,13.3s4.1-12.4,15-10.8c10,1.4,8.6,19.2,16.6,20.7,8,1.4,5-22.7,17.8-21.6,7.2.6,7.4,26,6.3,29.9s-2.2,11.3,3.7,10.8c4.8-.4,3.6-6.8,3-10.3-.6-3.9.3-18.3,1.4-22.9s7.7-4.4,9.1.3,4.3,45,4.2,47.4c-.3,6.4,10.1,5.4,7.7-.2-2.3-5.6-2.8-8.7-2.8-11.6,0-7,2.3-21.8,3-35,.3-6.7,6.8-12.7,11.8-9.5,5.9,3.8,4.6,25.5,4.6,25.5,0,0-3.6,14.1,1.6,15.4,7.6,1.8,5.9-9.3,4.5-14.4-1.4-5.2-.8-23.9,1.4-24.9,9.1-4.2,5.2,17.4,14.1,14.5,4.8-1.5,4.9-10.7,6.9-17.5,1.6-5.3,4.9-2.2,4.9-.6l.3,34c3.85-.42,6.62-3.89,6.2-7.73-.1-.9-.37-1.77-.8-2.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    className: "cls-47",
    d: "m313.59,156.07c0,12.3-44,22.2-98.2,22.2s-98.2-9.9-98.2-22.2,44-22.2,98.2-22.2c54.3.1,98.2,10,98.2,22.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    className: "cls-47",
    d: "m211.09,178.67c-43.6-.1-80-5.7-91.2-15.5-1.93-1.49-3.39-3.5-4.2-5.8-1-3.2-1.4-4.5-2.6-1.5-.28,1.28-.31,2.61-.1,3.9,2,14.3,43.3,21.5,96.9,20.2,5.8-.4,8.6-1.3,1.2-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    className: "cls-47",
    d: "m108.99,215.57c-.1-.9-1.2-.4-1.3.2-.56,1.68-.22,3.53.9,4.9.6.8,2.8,1,2-1.1-.7-1.26-1.24-2.6-1.6-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    className: "cls-47",
    d: "m135.39,188.17c-.54-3.1-2.13-5.93-4.5-8-5.5-4.6-11.4-3.9-17,.2-.7.5.1,1.1.9.6,7.7-4.9,16.2-.8,18.1,7.4,1.1,4.8-2.1,16.5,1,20.7.9,1.2,3.3-.2,1.9-3.4-2-4.8.7-12.4-.4-17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    className: "cls-47",
    d: "m152.99,221.77c-.1-.9-.8-1.4-1.4-.6-1.3,1.8-2.3,6.4.7,7.1.6.2,1.3-.6,1.4-1.2-.07-1.78-.3-3.56-.7-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    className: "cls-47",
    d: "m184.79,198.37c-5.8-1.5-5.7-8-10.6-10.7-2.9-1.7-5.9-1.7-9.3,0-.7.4-.6,1.1.2.8,2.87-1.05,6.08-.39,8.3,1.7,1.8,1.7,2.6,4.7,3.8,6.7,1.6,2.5,4.1,4.9,7.2,3.9,1.1-.3,1.9-2,.4-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    className: "cls-47",
    d: "m144.99,184.57c-.5.2-.3,1.3.3,1.2,1.94-.37,3.93.19,5.4,1.5,1.18,1.36,2.03,2.96,2.5,4.7.4.9,1.7.4,1.8-.4.38-3.85-2.43-7.28-6.27-7.66-1.28-.13-2.57.1-3.73.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    className: "cls-47",
    d: "m215.29,209.27c-1.2-.7-4.2-7.6-4.8-8.9-.79-1.92-1.76-3.76-2.9-5.5-1.65-2.76-4.84-4.19-8-3.6-.7.1-.5.6.4.6,8,.5,8.6,16.5,13.5,19.4,2.7,1.6,3.4-1.1,1.8-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    className: "cls-47",
    d: "m233.89,190.77c-.8-.2-1.5.3-.6.6,3.14,1.43,5.38,4.3,6,7.7.3,1.3,2,1.2,1.9,0-.3-4.3-3.3-7.2-7.3-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    className: "cls-47",
    d: "m242.69,225.87c-.4-1.2-1.5-1.3-2.1-.3-.93,1.11-1.27,2.6-.9,4,.26,1.19,1.43,1.94,2.62,1.68.1-.02.19-.05.28-.08,1.1-.6.4-4.4.1-5.3Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    className: "cls-44",
    d: "m138.89,124.57v26.9h0c.1,8.8,34.3,16,76.6,16s76.5-7.2,76.6-16h0v-26.9h-153.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    className: "cls-36",
    d: "m138.89,99.47v26.9h0c.1,8.8,34.3,16,76.6,16s76.5-7.2,76.6-16h0v-26.9h-153.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    className: "cls-47",
    d: "m138.89,77.47v24.8h0c.1,8.8,34.3,16,76.6,16s76.5-7.2,76.6-16h0v-24.8h-153.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    className: "cls-37",
    d: "m138.89,77.47v47h1v-17.8c.03-.98.17-1.95.4-2.9.86-2.46,3.56-3.76,6.02-2.9.92.32,1.71.92,2.28,1.7,1.6,2.2,2,3.3,2.6,6.8.68,3.62.99,7.31.9,11-.3,2.2-2.9,8,1.1,8.9,3.5.8,3.1-4.8,2.5-8-.6-3.1,2.1-12.7,5.6-12.8,6.9-.1,5.5,12,8.6,12.7s5.6-11.4,10.8-11.2,5,5.6,11.6,6.1c4.6.3,6.5-9.5,13.5-4.1,4.8,3.8,8.4,18.6,7.5,22.7s-3.1,11.3,1.6,11.4c4.7.2,4.2-4.8,3.1-10.5-1.1-5.6.3-13,8-13.5,9.6-.6,10.5,20.3,9.5,25.3-.9,5,1.3,9.1,4.7,6.6s.2-5.1,0-7.5c-.3-3.1-1.3-32.2,5.9-31.9s5.2,8.4,12.7,7.5c4.9-.6,7.7-22.2,13.6-17.8s6.8,26.2,5.9,28.5c-.5,1.3-2.7,9.2,2,9.2,5,0,3.1-5.5,2-9.5-1.1-3.9,1.3-30.7,5-33.2,2.6-1.7,3.9.1,4.7,2.2v-24.3h-153.1v.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    className: "cls-50",
    d: "m200.59,130.67c0-2.32-1.88-4.2-4.2-4.2s-4.2,1.88-4.2,4.2,1.88,4.2,4.2,4.2c2.31-.01,4.19-1.89,4.2-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    className: "cls-50",
    d: "m172.39,125.47c0-1.05-.85-1.9-1.9-1.9s-1.9.85-1.9,1.9c0,1.05.85,1.9,1.9,1.9h0c1.05,0,1.9-.85,1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    className: "cls-50",
    d: "m180.79,134.37c0-1.05-.85-1.9-1.9-1.9s-1.9.85-1.9,1.9c0,1.05.85,1.9,1.9,1.9h0c1.02.03,1.87-.76,1.9-1.78,0-.04,0-.08,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    className: "cls-50",
    d: "m261.59,128.77c0-1.55-1.25-2.8-2.8-2.8-1.55,0-2.8,1.25-2.8,2.8s1.25,2.8,2.8,2.8h0c1.55,0,2.8-1.25,2.8-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    className: "cls-46",
    d: "m255.49,148.97c0-1.27-1.03-2.3-2.3-2.3s-2.3,1.03-2.3,2.3,1.03,2.3,2.3,2.3h0c1.26-.01,2.29-1.04,2.3-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    className: "cls-46",
    d: "m277.09,154.07c0-1.27-1.03-2.3-2.3-2.3s-2.3,1.03-2.3,2.3,1.03,2.3,2.3,2.3h0c1.25.02,2.28-.97,2.3-2.22,0-.03,0-.05,0-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    className: "cls-46",
    d: "m264.89,156.47c0-.77-.63-1.4-1.4-1.4-.77,0-1.4.63-1.4,1.4,0,.77.63,1.4,1.4,1.4h0c.77-.02,1.38-.63,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    className: "cls-46",
    d: "m156.89,147.07c0-1.27-1.03-2.3-2.3-2.3-1.27,0-2.3,1.03-2.3,2.3s1.03,2.3,2.3,2.3h0c1.25.02,2.28-.98,2.3-2.23,0-.02,0-.05,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    className: "cls-46",
    d: "m167.19,155.47c0-.77-.63-1.4-1.4-1.4-.77,0-1.4.63-1.4,1.4,0,.77.63,1.4,1.4,1.4h0c.72.05,1.35-.49,1.4-1.22,0-.06,0-.12,0-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    className: "cls-46",
    d: "m190.19,155.47c0-1.27-1.03-2.3-2.3-2.3s-2.3,1.03-2.3,2.3,1.03,2.3,2.3,2.3h0c1.21.06,2.24-.88,2.3-2.1,0-.07,0-.14,0-.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    className: "cls-37",
    d: "m299.09,125.67c-.28-.95-.68-1.86-1.2-2.7-1.59-3.06-2.41-6.45-2.4-9.9l-.2-24.1h0v-5.5c-.1-3.8.6-9.2-4.9-13-11.2-6.9-40.4-11.8-74.8-11.8s-64.6,5.1-75.3,12.1c-4.3,3.1-4.4,8.9-4.4,12.1v6.1h0l-.1,19.6c-.01,2.65-.66,5.26-1.9,7.6-.49.85-.77,1.82-.8,2.8,1.6,7.6,5.9,5,5.9,5v-19.5c.03-.98.16-1.95.4-2.9.86-2.46,3.56-3.76,6.02-2.9.92.32,1.71.92,2.28,1.7,1.6,2.2,2,3.3,2.6,6.8.68,3.62.99,7.31.9,11-.3,2.2-2.9,8,1.1,8.9,3.5.8,3.1-4.9,2.5-8s2.1-12.7,5.6-12.8c6.9-.1,5.5,12,8.6,12.7s5.6-11.4,10.8-11.2,5,5.6,11.6,6.1c4.6.3,6.5-9.5,13.5-4.1,4.8,3.8,8.4,18.6,7.5,22.7s-3.1,11.3,1.6,11.4c4.7.2,4.2-4.8,3.1-10.5-1.1-5.6.3-13,8-13.5,9.6-.6,10.5,20.3,9.5,25.3-.9,5,1.3,9.1,4.7,6.6s.2-5.1,0-7.5c-.3-3.1-1.3-32.2,5.9-31.9s5.2,8.4,12.7,7.5c4.9-.6,7.7-22.2,13.6-17.8s6.8,26.2,5.9,28.5c-.5,1.3-2.7,9.2,2,9.2,5,0,3.1-5.5,2-9.5-1.1-3.9,1.3-30.7,5-33.2,5-3.3,5.5,6.6,5.5,6.6v23.5s1.3,5.7,4.8,3.8c2.03-.9,3.06-3.18,2.4-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    className: "cls-47",
    d: "m216.29,92.07c-34.6-.1-64.3-5.4-72.2-12.8-1.29-1.03-2.18-2.48-2.5-4.1-.4-2.6-2.2-3.2-3.4-.5-.28.8-.41,1.65-.4,2.5.4,11.5,35.2,17,77.7,16,4.4-.3,6.6-1.1.8-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    className: "cls-47",
    d: "m152.99,122.17c0-.7-.9-.7-1.3-.4-.92.54-1.22,1.72-.68,2.64.1.17.23.33.38.46.48.38,1.18.3,1.56-.19.16-.2.24-.45.24-.71-.02-.6-.08-1.21-.2-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    className: "cls-47",
    d: "m136.09,117.17c0-.7-.9-.7-1.3-.4-.92.54-1.22,1.72-.68,2.64.1.17.23.33.38.46.48.38,1.18.3,1.56-.19.16-.2.24-.45.24-.71-.12-.59-.19-1.2-.2-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    className: "cls-47",
    d: "m149.19,96.37c-3-1.9-7.6-2-9.7,1.2-.5.7.2.7.8.3,3.1-2.3,7.1-.9,9.2,1.9,2.03,2.96,3.01,6.52,2.8,10.1,0,1.1,1.1-1.8,1.1-3.8,0-3.7-.6-7.3-4.2-9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    className: "cls-47",
    d: "m167.39,106.97c-1.14-1.92-3.17-3.12-5.4-3.2-.5,0-.9.6-.3.8,2.7,1,3.5,2.1,4.6,4.3,1,2.2,1.2,4.2,2.1,6.9.4,1.1,1.7.5,1.7-1.1-.15-2.77-1.09-5.44-2.7-7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    className: "cls-47",
    d: "m190.39,110.77c-2.6-.2-4.6-3.7-6.1-4.6-1.51-.79-3.25-1-4.9-.6-.8.2-.5.7.4.6,1.4-.2,3.4,1.5,4.2,2.3.9.9,3.6,4.1,5.8,4.2,2.7.1,2.5-1.7.6-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    className: "cls-47",
    d: "m203.99,106.67c-.9-.1-1.5.3-.4.7,5.8,1.8,8.2,8.3,9.2,13.7.2,1.3.5.1.5-1,0-6.5-2.6-12.4-9.3-13.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    className: "cls-47",
    d: "m215.09,137.07c0-.7-.9-.6-1.2-.2-.8,1.2-1.3,2.6-.5,3.8.37.55,1.12.7,1.68.32.37-.25.57-.68.52-1.12-.22-.92-.39-1.86-.5-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    className: "cls-47",
    d: "m238.09,147.97c-.21-.46-.52-.87-.9-1.2-.4-.35-1.01-.31-1.36.09-.05.06-.1.13-.14.21-.49.79-.52,1.78-.1,2.6.6,1.9,3.4.8,2.5-1.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    className: "cls-47",
    d: "m287.69,75.07c0,9-32.3,16.3-72.2,16.3s-72.2-7.3-72.2-16.3,32.3-16.3,72.2-16.3c39.9-.1,72.2,7.2,72.2,16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    className: "cls-37",
    d: "m112.99,154.37s1.4,4.5,5.2,6.1,5.9.5,7.3,1.6c1.4,1.2,6.8,3.3,6.8,3.3,3.6-.4.5,2.3,7.3,4.9,2.9,1.1,9.2.2,12,.9s9.9-1.2,11.7-.9c1.9.2,4,4.9,9.2,6.6,5.2,1.6,10.3-2.3,14.8-2.1,3.5.2,8-.2,11.7.2,3.8.5,7.3,3.9,12.2,3.7s18.7.7,21.3-.7,3.1-4.2,6.3-3.3c3.3.9,10.6,2.1,13.8,1.9,3.3-.2,8-3.5,10.1-2.8s16.2.9,19.9-.9c3.8-1.9,4.9-8.9,7.7-8.2s13.6,0,15.7-2.1,5.6-2.1,7.7-5.2c1.25-1.61.98-3.92-.6-5.2l-53.2,9-53,5.4-36.8-3.3-42-7.7-15.1-1.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    className: "cls-37",
    d: "m204.39,138.57c-.1,0-.1-.1-.2-.1q.1.1.2.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    className: "cls-56",
    d: "m213.89,41.47h-2.4v40.6h9.2v-40.6h-6.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    className: "cls-37",
    d: "m211.49,77.57c2.91,1.41,6.01,2.39,9.2,2.9v-5.1c-3.19-.57-6.28-1.58-9.2-3v5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    className: "cls-56",
    d: "m211.49,72.27c2.9,1.46,6,2.47,9.2,3v-5.1c-3.2-.62-6.3-1.7-9.2-3.2v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    className: "cls-56",
    d: "m211.49,82.07h9.2v-1.7c-3.19-.51-6.29-1.49-9.2-2.9v4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    className: "cls-37",
    d: "m211.49,66.97c2.9,1.5,6,2.58,9.2,3.2v-5.1c-3.21-.7-6.3-1.85-9.2-3.4v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    className: "cls-56",
    d: "m220.69,41.47h-7.1c2.24,1.24,4.63,2.22,7.1,2.9v-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    className: "cls-37",
    d: "m213.59,41.47h-2.1v4.1c2.87,1.74,5.97,3.09,9.2,4v-5.2c-2.47-.7-4.85-1.67-7.1-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    className: "cls-56",
    d: "m211.49,50.97c2.88,1.67,5.98,2.95,9.2,3.8v-5.2c-3.25-.87-6.35-2.22-9.2-4v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    className: "cls-56",
    d: "m211.49,61.57c2.9,1.55,5.99,2.7,9.2,3.4v-5.1c-3.23-.73-6.33-1.94-9.2-3.6v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    className: "cls-37",
    d: "m211.49,56.27c2.89,1.62,5.98,2.83,9.2,3.6v-5.1c-3.24-.81-6.34-2.09-9.2-3.8v5.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m211.49,41.47c0,.3,2.1.6,4.6.6s4.6-.3,4.6-.6-2.1-.6-4.6-.6-4.6.3-4.6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m213.89,41.47c0,.2,1,.3,2.2.3s2.2-.1,2.2-.3-1-.3-2.2-.3-2.2.1-2.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m215.89,36.57l-.2,4.6c0,.22.18.4.4.4.22,0,.4-.18.4-.4h0l-.2-4.6c0-.16-.14-.29-.3-.3-.07.08-.11.19-.1.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    className: "cls-56",
    d: "m182.29,32.67h-2.4v40.7h9.2v-40.7h-6.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    className: "cls-37",
    d: "m179.89,68.77c2.91,1.41,6.01,2.39,9.2,2.9v-5.1c-3.19-.57-6.28-1.58-9.2-3v5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    className: "cls-36",
    d: "m179.89,63.47c2.9,1.46,6,2.47,9.2,3v-5.1c-3.2-.62-6.3-1.7-9.2-3.2v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    className: "cls-36",
    d: "m179.89,73.37h9.2v-1.7c-3.19-.51-6.29-1.49-9.2-2.9v4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    className: "cls-37",
    d: "m179.89,58.17c2.9,1.5,6,2.58,9.2,3.2v-5.1c-3.21-.7-6.3-1.85-9.2-3.4v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    className: "cls-36",
    d: "m189.09,32.67h-7.1c2.24,1.24,4.63,2.22,7.1,2.9v-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    className: "cls-37",
    d: "m181.99,32.67h-2.1v4.1c2.87,1.74,5.97,3.09,9.2,4v-5.2c-2.47-.68-4.86-1.66-7.1-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    className: "cls-36",
    d: "m179.89,42.17c2.88,1.67,5.98,2.95,9.2,3.8v-5.2c-3.25-.87-6.35-2.22-9.2-4v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    className: "cls-36",
    d: "m179.89,52.87c2.9,1.55,5.99,2.7,9.2,3.4v-5.1c-3.23-.73-6.33-1.94-9.2-3.6v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    className: "cls-37",
    d: "m179.89,47.57c2.89,1.62,5.98,2.83,9.2,3.6v-5.1c-3.24-.81-6.34-2.09-9.2-3.8v5.3Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-50",
    cx: 184.49,
    cy: 32.67,
    rx: 4.6,
    ry: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m182.29,32.67c0,.2,1,.3,2.2.3s2.2-.1,2.2-.3-1-.3-2.2-.3c-.74,0-1.49.09-2.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m184.19,27.77l-.2,4.6c0,.22.18.4.4.4.22,0,.4-.18.4-.4h0s-.2-4.6-.2-4.6c0-.16-.14-.29-.3-.3,0,.1-.1.2-.1.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    className: "cls-56",
    d: "m248.59,32.67h-2.4v40.7h9.2v-40.7h-6.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    className: "cls-37",
    d: "m246.19,68.77c2.91,1.41,6.01,2.39,9.2,2.9v-5.1c-3.19-.57-6.28-1.58-9.2-3v5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    className: "cls-44",
    d: "m246.19,63.47c2.9,1.46,6,2.47,9.2,3v-5.1c-3.2-.62-6.3-1.7-9.2-3.2v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    className: "cls-44",
    d: "m246.19,73.37h9.2v-1.7c-3.19-.51-6.29-1.49-9.2-2.9v4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    className: "cls-37",
    d: "m246.19,58.17c2.9,1.5,6,2.58,9.2,3.2v-5.1c-3.21-.7-6.3-1.85-9.2-3.4v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    className: "cls-44",
    d: "m255.39,32.67h-7.1c2.24,1.24,4.63,2.22,7.1,2.9v-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    className: "cls-37",
    d: "m248.29,32.67h-2.1v4.1c2.87,1.74,5.97,3.09,9.2,4v-5.2c-2.47-.68-4.86-1.66-7.1-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    className: "cls-44",
    d: "m246.19,42.17c2.88,1.67,5.98,2.95,9.2,3.8v-5.2c-3.25-.87-6.35-2.22-9.2-4v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    className: "cls-44",
    d: "m246.19,52.87c2.9,1.55,5.99,2.7,9.2,3.4v-5.1c-3.23-.73-6.33-1.94-9.2-3.6v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    className: "cls-37",
    d: "m246.19,47.57c2.89,1.62,5.98,2.83,9.2,3.6v-5.1c-3.24-.81-6.34-2.09-9.2-3.8v5.3Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-46",
    cx: 250.79,
    cy: 32.67,
    rx: 4.6,
    ry: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m248.59,32.67c0,.2,1,.3,2.2.3s2.2-.1,2.2-.3-1-.3-2.2-.3c-.74,0-1.48.1-2.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m250.49,27.77l-.2,4.6c0,.22.18.4.4.4.22,0,.4-.18.4-.4h0l-.2-4.6c0-.16-.14-.29-.3-.3,0,.1-.1.2-.1.3Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576",
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    className: "cls-52",
    d: "m323.69,213.77c-1.58-2.77-2.41-5.91-2.4-9.1,0,0,.4-24.1-.1-37.8-.3-8-2.2-16.6-14.8-21.6-4.7-1.76-9.51-3.2-14.4-4.3v-13.1c.4,1.3,1.8,4.9,4.6,3.3,2.03-1.06,3.03-3.4,2.4-5.6-.28-.95-.68-1.86-1.2-2.7-1.59-3.06-2.41-6.45-2.4-9.9l-.2-24.1h0v-5.5c-.1-3.8.6-9.2-4.9-13-6.5-4-18.9-7.3-34.9-9.4v-28.3c0-.3-1.8-.6-4.2-.6l-.2-4.3c0-.17-.13-.3-.3-.3s-.3.13-.3.3l-.2,4.3c-2.3,0-4.2.3-4.2.6h0v27.2c-7.9-.7-16.5-1.2-25.5-1.3v-17.3h0c0-.3-1.8-.6-4.2-.6l-.2-4.3c0-.17-.13-.3-.3-.3s-.3.13-.3.3h0l-.2,4.3c-2.3,0-4.2.3-4.2.6h0v17.2c-7.8.1-15.4.4-22.5,1v-26.9c0-.3-1.8-.6-4.2-.6l-.2-4.3c0-.17-.13-.3-.3-.3s-.3.13-.3.3h0l-.2,4.3c-2.3,0-4.2.3-4.2.6h0v27.8c-18.5,2.1-32.9,5.8-39.7,10.2-4.3,3.1-4.4,8.9-4.4,12.1v6.1h0l-.1,19.6c-.01,2.65-.66,5.26-1.9,7.6-.49.85-.77,1.82-.8,2.8,1.6,7.3,5.6,5.2,5.9,5.1v17c-5.67,1.26-11.22,3-16.6,5.2-11.1,5-12.5,13.5-12.5,16.9v39.1c0,4.2-1,8.35-2.9,12.1-.78,1.55-.95,3.33-.5,5,1.3,5.4,5.1,6.5,6.2,6.7v14.7h0c.1,11.9,46.1,21.5,102.9,21.5s102.8-9.6,102.9-21.5h0v-16.4c2.76-.26,5.09-2.15,5.9-4.8,1.1-1.2,1.2-3.7.1-5.6Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575",
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "m323.69,213.77c-1.58-2.77-2.41-5.91-2.4-9.1,0,0,.4-24.1-.1-37.8-.3-8-2.2-16.6-14.8-21.6-4.7-1.76-9.51-3.2-14.4-4.3v-13.1c.4,1.3,1.8,4.9,4.6,3.3,2.03-1.06,3.03-3.4,2.4-5.6-.28-.95-.68-1.86-1.2-2.7-1.59-3.06-2.41-6.45-2.4-9.9l-.2-24.1h0v-5.5c-.1-3.8.6-9.2-4.9-13-6.5-4-18.9-7.3-34.9-9.4v-28.3c0-.3-1.8-.6-4.2-.6l-.2-4.3c0-.17-.13-.3-.3-.3s-.3.13-.3.3l-.2,4.3c-2.3,0-4.2.3-4.2.6h0v27.2c-7.9-.7-16.5-1.2-25.5-1.3v-17.3h0c0-.3-1.8-.6-4.2-.6l-.2-4.3c0-.17-.13-.3-.3-.3s-.3.13-.3.3h0l-.2,4.3c-2.3,0-4.2.3-4.2.6h0v17.2c-7.8.1-15.4.4-22.5,1v-26.9c0-.3-1.8-.6-4.2-.6l-.2-4.3c0-.17-.13-.3-.3-.3s-.3.13-.3.3h0l-.2,4.3c-2.3,0-4.2.3-4.2.6h0v27.8c-18.5,2.1-32.9,5.8-39.7,10.2-4.3,3.1-4.4,8.9-4.4,12.1v6.1h0l-.1,19.6c-.01,2.65-.66,5.26-1.9,7.6-.49.85-.77,1.82-.8,2.8,1.6,7.3,5.6,5.2,5.9,5.1v17c-5.67,1.26-11.22,3-16.6,5.2-11.1,5-12.5,13.5-12.5,16.9v39.1c0,4.2-1,8.35-2.9,12.1-.78,1.55-.95,3.33-.5,5,1.3,5.4,5.1,6.5,6.2,6.7v14.7h0c.1,11.9,46.1,21.5,102.9,21.5s102.8-9.6,102.9-21.5h0v-16.4c2.76-.26,5.09-2.15,5.9-4.8,1.1-1.2,1.2-3.7.1-5.6Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Flame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    className: "cls-55",
    d: "m214.94,27.02c-.19-3.48,4.5,5.3,4.4,9.29s-3.51,3.63-3.51,3.63c0,0-3.75-.11-3.38-3.63s2.68-5.81,2.49-9.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    className: "cls-48",
    d: "m215.29,31.89c-.12-2.17,2.8,3.3,2.74,5.79s-2.19,2.27-2.19,2.27c0,0-2.34-.07-2.11-2.27s1.67-3.62,1.55-5.79Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Flame-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_421-2",
    "data-name": "Path 421-2",
    className: "cls-55",
    d: "m249.76,17.17c-.19-3.48,4.5,5.3,4.4,9.29s-3.51,3.63-3.51,3.63c0,0-3.75-.11-3.38-3.63s2.68-5.81,2.49-9.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422-2",
    "data-name": "Path 422-2",
    className: "cls-48",
    d: "m250.11,22.04c-.12-2.17,2.8,3.3,2.74,5.79s-2.19,2.27-2.19,2.27c0,0-2.34-.07-2.11-2.27s1.67-3.62,1.55-5.79Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Flame-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_421-3",
    "data-name": "Path 421-3",
    className: "cls-55",
    d: "m182.88,17.17c-.19-3.48,4.5,5.3,4.4,9.29s-3.51,3.63-3.51,3.63c0,0-3.75-.11-3.38-3.63s2.68-5.81,2.49-9.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422-3",
    "data-name": "Path 422-3",
    className: "cls-48",
    d: "m183.24,22.04c-.12-2.17,2.8,3.3,2.74,5.79s-2.19,2.27-2.19,2.27c0,0-2.34-.07-2.11-2.27s1.67-3.62,1.55-5.79Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    y: 5.89,
    width: 430,
    height: 273
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingCake);
export default __webpack_public_path__ + "static/media/PendingCake.f0a12c51b77537127bbfa8a78392a93e.svg";
export { ForwardRef as ReactComponent };